import React from "react";
import "./Radio2.scss";

function Radio2({ label, value, selectedValue, onChange, disabled = false }) {
    return (
        <label className={`radio_label ${disabled ? "disabled" : ""}`}>
            <input
                type="radio"
                className="radio_input"
                value={value}
                checked={selectedValue === value}
                onChange={() => !disabled && onChange(value)}
                disabled={disabled} // input 자체도 disabled 처리
            />
            <span className={`custom_radio ${disabled ? "disabled_icon" : ""}`} />
            {label}
        </label>
    );
}

export default Radio2;
